import { gsap, ScrollTrigger } from "@gsap";
/**
 * Layout: Themes
 * Slug: themes
 */

document.addEventListener("DOMContentLoaded", function () {
	gsap.registerPlugin(ScrollTrigger);
	const layouts = document.querySelectorAll(".flex-layout.themes-layout");

	layouts.forEach((layout) => {
		gsap.from(layout.querySelectorAll(".theme-button"), {
			y: -20,
			autoAlpha: 0,
			stagger: 0.1,
			scrollTrigger: {
				trigger: layout.querySelector(".themes-col"),
				start: "top center+=25%",
				markers: false,
			},
		});
	});
});
